import { isEmpty, map, size } from "lodash";
import React, { useRef } from "react";

import viewProfileImg from "@/assets/images/svg/viewProfileImg.svg";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { motion } from "framer-motion";

const Testimonials = ({ testimonialData }) => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const testimonialRef = useRef(null);

  const options = {
    loop: true,
    margin: 24,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 70000,
    autoplayHoverPause: true,
    video: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
      1280: { items: 2 },
      1440: { items: 2 },
    },
  };

  const goToNext = () => {
    testimonialRef.current.next();
  };

  const goToPrev = () => {
    testimonialRef.current.prev();
  };

  function extractYouTubeID(url) {
    // const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(youtubeRegex);
    return match ? match[1] : null;
  }

  return (
    <>
      <section className={`testimonial-wrape`}

      >
        <div className="container">
          <div className="row">
            <div className="col-xxl-1 col-xl-1 col-lg-12 col-md-12"></div>
            <div className="col-xxl-10 col-xl-10 col-lg-12 col-md-12">
              <div className="head-text center">
                <motion.h2 className={`head center animate-child`}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >Client Testimonials</motion.h2>
                <motion.p className={`text animate-child`}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >
                  Discover how our solutions have transformed businesses and helped clients achieve their goals.
                </motion.p>
              </div>
            </div>
          </div>
        </div>

        {size(testimonialData) > 0 && <motion.div
          className="animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          custom={0.1}
          variants={fadeUpVariant}
        >
          <OwlCarousel className="owl-theme" {...options} ref={testimonialRef} key={testimonialData?.length} >
            {
              map(testimonialData, (val, idx) => {
                let embedURL = '';
                if (val.type == "VIDEO") {
                  if (!isEmpty(val.video_link)) {
                    let v = val.video_link;
                    if (v.includes('youtube.com') || v.includes('youtu.be')) {
                      const youtubeID = extractYouTubeID(v);
                      if (youtubeID) {
                        embedURL = `https://www.youtube.com/embed/${youtubeID}`;
                      } else {
                        console.error('Invalid YouTube URL');
                      }
                    }

                    if (!isEmpty(embedURL)) {
                      return (
                        <div
                          className="t-item vdo"
                          key={`inner_div_item_${idx}`}
                        >
                          <div className="detail--">
                            <div className="item-video">
                              <iframe
                                src={`${embedURL}`}
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                style={{ width: '100%', height: '400px' }}
                              ></iframe>
                            </div>
                          </div>

                        </div>
                      );
                    }
                  }
                }
                if (val.type == "TEXT") {
                  return (<div
                    className="t-item"
                    key={`inner_div_item_${idx}`}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: val?.comment,
                      }}
                      className="inner-scroll-pad"

                    ></div>
                    <div className="author-wrape">
                      <div className="thumb">
                        {val?.image ? (
                          <img src={val.image} alt={val?.contact_person_name} loading="lazy" style={{ width: "100px", height: "'100px" }} />
                        ) : (
                          <img src={viewProfileImg} alt={val?.contact_person_name} loading="lazy" style={{ width: "100px", height: "'100px" }} />
                        )}
                      </div>
                      <div className="detail">
                        <p>
                          {val?.contact_person_name}
                          <span>{val?.designation}, {val?.company_name}</span>
                        </p>
                      </div>
                    </div>
                  </div>)
                }
                return null;
              })
            }
          </OwlCarousel>
        </motion.div>
        }

        <div className="nav-ctrl">
          <button type="button" className="btn prev" onClick={goToPrev}>
            <i className="sprite"></i>
          </button>
          <button type="button" className="btn next" onClick={goToNext}>
            <i className="sprite"></i>
          </button>
        </div>

      </section>
    </>
  );
};

export default Testimonials;
